module.exports = "b, strong {\n  font-weight: 600;\n  display: block; }\n\n.modal-body {\n  height: 350px;\n  overflow-y: scroll; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/privacy-modal/privacy-modal.component.scss
// module id = ./src/app/shared/privacy-modal/privacy-modal.component.scss
// module chunks = main